"use client"

import { useMutation } from "@tanstack/react-query"
import {
  cleanAllKnowledgeBaseAction,
  type CleanAllKnowledgeBaseResult,
} from "@/server-actions/knowledge-base-clean-all"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export function useCleanAllKnowledgeBaseMutation(options?: {
  onSuccess?: (result: CleanAllKnowledgeBaseResult) => void | Promise<void>
}) {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsKnowledgeBaseCleanAll")

  return useMutation({
    mutationFn: async (): Promise<CleanAllKnowledgeBaseResult> => {
      const result = await withQueryHandling(cleanAllKnowledgeBaseAction({}), {
        loading: tUi("cleaningKnowledgeBase"),
        success: (value) => `Deleted ${(value as CleanAllKnowledgeBaseResult).deletedDocuments} documents`,
      })

      return result as CleanAllKnowledgeBaseResult
    },
    onSuccess: options?.onSuccess,
  })
}
